import { REQUEST_STATUS } from '../../../../constants/request'
import { getRequestProfilePathname } from '../../../../utils/link'
import { EntityArchivedIcon } from '../../../Entity'
import {
  TableBuildingCell,
  TableContext,
  TableDueDateCell,
  TableFlatCell,
  TableRequestNoCell,
  TableStatusCell,
  TableTitleCell,
  TableUserCell,
  TableUserListCell,
} from '../../../Table'
import { toUserMultiValue } from '../../../User'
import { ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME } from '../AttachServiceRequestsModal.constants'

import * as styles from './AttachServiceRequestsModalTableRow.module.css'

export function renderCell({
  availableSections,
  extra,
  item,
  name,
  ...restProps
}) {
  const { archived, id, labels, [name]: value } = item

  switch (name) {
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.requestNo:
      return (
        <TableRequestNoCell
          {...restProps}
          id={id}
          linkTo={getRequestProfilePathname({ availableSections, id })}
          value={value}
        />
      )
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.title:
      return (
        <TableTitleCell
          {...restProps}
          TextArchivedIcon={archived ? EntityArchivedIcon : null}
          context={TableContext.Request}
          extra={extra}
          id={id}
          labels={labels}
          tagsInteractable={false}
          textArchivedIconProps={{
            containerClassName: styles.archivedIconContainer,
          }}
          value={value}
        />
      )
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.building:
      return <TableBuildingCell {...restProps} id={id} value={value} />
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.flat:
      return <TableFlatCell {...restProps} value={value} />
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={REQUEST_STATUS}
          value={value}
        />
      )
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.deadline:
      return (
        <TableDueDateCell {...restProps} status={item.status} value={value} />
      )
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.assignees:
      return (
        <TableUserListCell
          {...restProps}
          value={value?.map(toUserMultiValue)}
        />
      )
    case ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME.manager:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
  }
}
